var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('h1',[_vm._v("404")]),_vm._m(0),_c('router-link',{staticClass:"button",attrs:{"to":"/"}},[_vm._v("Back to Home")])],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',[_vm._v(" This page does not exist."),_c('br'),_vm._v(" Please go back to our home page.")])
}]

export { render, staticRenderFns }